import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Navbar from '../common/Navbar'
import ItWorks from '../subcompo/sections-home/ItWorks';
import Footer from '../common/Footer';
import Loader from '../common/Loader';
import $ from 'jquery';

class HowItWorksQuotes extends Component {
  componentDidMount() {
    // ReactDOM.findDOMNode(this).scrollTop = 0
    $("html, body").animate({ scrollTop: 0 }, 250);
  }
  render() {
     return (
       <div>
        <Navbar/>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="text-center">Quotes</h2>
              <p className="text-center">
              <img src={require('../../images/work_2.jpg')} className="text-center" alt='' />
              </p>
              <p className="secDesc" style={{marginTop: "30px"}}>
              With little more info, our quote engine will provide you full-blown ‘bindable’ quotes from all interested carriers, allowing you to choose most preferred option.
              </p>
            </div>
          </div>
        </div>
        <ItWorks/>
        <Footer/>
        <Loader/>
      </div>
    );
  }
}

export default HowItWorksQuotes;
